import React, { useCallback, useEffect, useState } from "react";
import classnames from "classnames";
import Button from "./../Button";

import "./backToTop.scss";

const BackToTop = () => {
  const [visible, setVisible] = useState(false);
  const heightOffset = window.innerHeight / 2;

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollHandler = useCallback(() => {
    if (!visible && window.scrollY >= heightOffset) {
      setVisible(true);
    } else if (visible && window.scrollY < heightOffset) {
      setVisible(false);
    }
  }, [visible, setVisible, heightOffset]);

  useEffect(() => {
    window.addEventListener("scroll", scrollHandler);

    return () => window.removeEventListener("scroll", scrollHandler);
  }, [scrollHandler]);

  return (
    <Button
      className={classnames("back-to-top", { "is-visible": visible })}
      variant="outline"
      size="large"
      iconName="system-arrow-up"
      iconSize="medium"
      aria-label="Back To Top"
      onClick={handleScrollToTop}
    />
  );
};

export default BackToTop;
